module.exports = __webpack_public_path__ + "static/media/Programming-pana-purple.db9dc282.svg";